import { render, staticRenderFns } from "./BulkVideoUploadModal.vue?vue&type=template&id=67189611&"
import script from "./BulkVideoUploadModal.vue?vue&type=script&lang=js&"
export * from "./BulkVideoUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports